<template>
  <div class="mt-component-form print-container">
    <vs-row  v-if="isShowTitle">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> {{title}}
        </h5>
      </vs-col>
    </vs-row>

    <!-- 테이블 헤더 -->
    <div class="mt-4 grid row-header" :style="`grid-template-columns: 260px 1fr repeat(4, 80px) ${isNote ? headerWidthNote : ''}`">
      <div class="row-header__item">{{tableHeaderLabel}}</div>
      <div class="row-header__item">{{tableHeaderContent}}</div>
      <div class="row-header__item">{{tableHeaderScore}}</div>
      <div class="row-header__item">{{tableHeaderGood}}</div>
      <div class="row-header__item">{{tableHeaderNormal}}</div>
      <div class="row-header__item">{{tableHeaderBad}}</div>
      <div v-if="isNote" class="row-header__item">{{tableHeaderNote}}</div>
    </div>


    <!-- 테이블 본문 영역 -->
    <div class="grid row-content__body-item"
         v-for="(rows, indexRows) in list" :key="indexRows"
         :style="{ gridTemplateColumns: `260px 1fr repeat(4, 80px) ${isNote ? headerWidthNote : ''}`,
         borderBottom: (indexRows === list.length - 1 ? '1px solid #cdcdcd' : '')}"
    >
      <!-- title 속성이 지정된 경우, 표시한다 (중복될 경우 무시한다) -->
      <div v-if="rows.title && rows.title !== ''
            && (indexRows === 0 || list[indexRows].title !== list[indexRows - 1].title)"
           class="col-span-12 item-title" :style="`background-color: ${rows.titleColor}`">
        <b>{{rows.title}}</b>
      </div>

<!--      항목 구분-->
      <div v-if="rows.group" class="grid " :style="'grid-template-columns: 100px 1fr'" :set="(groupData = rows.group)">
        <div v-if="indexRows==0 || (list[indexRows - 1].group != groupData)" class="border-right" style="display: flex;justify-content: center;align-items: center;background-color: #F9F9F9; white-space:pre-line" v-text="rows.group"></div>
        <div v-else></div>
        <div class="item-content">
          <span v-if="isNotDotInLabel" class="row-title-nodot" style="white-space:pre-line" v-text="rows.label"></span>
          <span v-else class="row-title" style="white-space:pre-line" v-text="rows.label"></span>
        </div>
      </div>
      <!-- 항목 이름  -->
      <div v-else class="item-content">
        <span v-if="isNotDotInLabel" class="row-title-nodot" style="white-space:pre-line" v-text="rows.label"></span>
        <span v-else class="row-title" style="white-space:pre-line" v-text="rows.label"></span>
      </div>

      <!--      컨텐츠-->
      <div class="item-box">
        <span class="item-box-center" style="white-space:pre-line" v-text="rows.content"></span>
      </div>

      <!--      배점-->
      <div class="item-box">
        <span class="item-box-center" style="white-space:pre-line" v-text="rows.score"></span>
      </div>

      <!-- good -->
      <div class="item-box">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="rows.is_checked === 'good'">
            <span>{{rows.good}}</span>
            <vs-icon icon="check" size="small"  ></vs-icon>
          </div>
          <div v-else class="item-box-check">
            <span>{{rows.good}}</span>
          </div>
        </template>
        <div v-else class="item-box-check">
          <span>{{rows.good}}</span>
          <vs-checkbox
            style="padding-left: 10px;"
            :disabled="isReadonly"
            :checked="rows.is_checked === 'good'"
            @change="checkForm($event, rows.id, 'good')"
          ></vs-checkbox>
        </div>
      </div>

      <!-- normal -->
      <div class="item-box">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="rows.is_checked === 'normal'">
            <span>{{rows.normal}}</span>
            <vs-icon icon="check" size="small"  ></vs-icon>
          </div>
          <div v-else class="item-box-check">
            <span>{{rows.normal}}</span>
          </div>
        </template>
        <div v-else class="item-box-check">
          <span>{{rows.normal}}</span>
          <vs-checkbox
            style="padding-left: 10px;"
            :disabled="isReadonly"
            :checked="rows.is_checked === 'normal'"
            @change="checkForm($event, rows.id, 'normal')"
          ></vs-checkbox>
        </div>
      </div>

      <!-- bad -->
      <div class="item-box">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="rows.is_checked === 'bad'">
            <span>{{rows.bad}}</span>
            <vs-icon icon="check" size="small"  ></vs-icon>
          </div>
          <div v-else class="item-box-check">
            <span>{{rows.bad}}</span>
          </div>
        </template>
        <div v-else class="item-box-check">
          <span>{{rows.bad}}</span>
          <vs-checkbox
            style="padding-left: 10px;"
            :disabled="isReadonly"
            :checked="rows.is_checked === 'bad'"
            @change="checkForm($event, rows.id, 'bad')"
          ></vs-checkbox>
        </div>
      </div>

      <!-- 비고 -->
      <div v-if="isNote" class="item-note border-right">
        <span v-if="isPrint" class="print-input"> {{rows.note}} </span>
        <ml-input v-else class="w-full flex-1" v-model="rows.note" @change="updateRowNote($event, rows.id, rows.note)"  :readonly="isReadonly"/>
      </div>
    </div>

    <!--    합계-->
    <div class="grid row-content__body-item"
         :style="{ gridTemplateColumns: `261px 1fr 80px 240px ${isNote ? headerWidthNote : ''}`,
        border: 'none', backgroundColor: '#F9F9F9'}"
    >
      <div class="item-box">
        <span class="item-box-check" style="padding-top: 10px; padding-bottom: 10px; border-bottom: 1px solid #CDCDCD">{{ $t('합계') }}</span>
      </div>
      <div class="item-box">
        <span class="item-box-check" style="padding-top: 10px; padding-bottom: 10px; border-bottom: 1px solid #CDCDCD; height: 100%;"></span>
      </div>
      <div class="item-box">
        <span class="item-box-check" style="padding-top: 10px; padding-bottom: 10px; border-bottom: 1px solid #CDCDCD">{{sumScore}}</span>
      </div>
      <div class="item-box">
        <span class="item-box-check" style="padding-top: 10px; padding-bottom: 10px; border-bottom: 1px solid #CDCDCD">{{sumValue}}</span>
      </div>
    </div>
<!--    borderBottom: '1px solid #cdcdcd',-->
    <div v-if="isBottomNote" class="flex items-center mt-4">
      <div class="label-text mr-4">{{ bottomNoteTitle }}</div>
      <p v-if="isPrint" class="w-full flex-1">{{ bottomNote }}</p>
      <ml-textarea
        v-else
        class="flex-1 w-full"
        rows="5"
        :readonly="isReadonly"
        v-model="bottomNote"
        @change="updateBottomNote()"
      />
    </div>

    <!-- footer 지정된 경우, 표시한다 (중복될 경우 무시한다) -->
    <div v-if="footer && footer !== ''" class="row-header__item justify-start">
      <b class="ml-2">{{footer}}</b>
    </div>

  </div>


</template>

<script>
import config from '../../public/config'
import {groupData} from "echarts/lib/util/model";
export default {
  name: 'TableScore',
  props: {
    isPrint: Boolean,
    isReadonly: Boolean,
    /**
     * 테이블 상단에 동그라미(●) 제목을 표시할지 여부
     */
    isShowTitle: Boolean,
    /**
     * 가장 오른쪽 열에 "비고" 칸을 표시할지 여부
     * 은평 branch 에서는 "비고" 칸이 기본으로 노출된다
     */
    isNote: {
      type: Boolean,
      default: true,
    },
    title: String,
    list: Array,
    tableHeaderLabel: {
      type: String,
      default: '항목'
    },
    tableHeaderContent: {
      type: String,
      default: '기준'
    },
    tableHeaderScore: {
      type: String,
      default: '배점'
    },
    tableHeaderGood: {
      type: String,
      default: '우수'
    },
    tableHeaderNormal: {
      type: String,
      default: '보통'
    },
    tableHeaderBad: {
      type: String,
      default: '미흡'
    },
    tableHeaderNote: {
      type: String,
      default: '비고'
    },
    headerWidthYes: {
      type: String,
      default: '130px',
    },
    headerWidthNo: {
      type: String,
      default: '130px',
    },
    headerWidthNa: {
      type: String,
      default: '130px',
    },
    headerWidthNote: {
      type: String,
      default: '388px',
    },
    footer: String,
    isNotDotInLabel: Boolean,
    isBottomNote: {
      type: Boolean,
      default: false,
    },
    bottomNoteTitle : {
      type: String,
      default: '기타의견'
    },
    initBottomNote: {
      type: String,
      default: '',
    }
  },
  emits: ['update-list-check', 'update-note', 'update-bottom-note', 'update-value'],
  methods: {
    groupData,
    checkForm (value, indexRows, text) {
      if (value.target.checked) {
        this.$emit('update-list-check', indexRows - 1, text)
      } else {
        this.$emit('update-list-check', indexRows - 1, '')
      }
    },

    updateRowNote (value, indexRows, text) {
      this.$emit('update-note', indexRows - 1, text)
    },

    updateBottomNote() {
      this.$emit('update-bottom-note', this.bottomNote);
    }
  },
  data () {
    return {
      hostname: config.HOST_NAME,
      bottomNote: this.initBottomNote,
    }
  },
  computed: {
    sumScore () {
      return this.list.reduce((acc, cur) => {
        return acc + cur.score
      }, 0)
    },
    sumValue () {
      return this.list.reduce((acc, cur) => {
        let result = 0;
        if (cur.is_checked === 'good') {
          result = acc + cur.good
        } else if (cur.is_checked === 'normal') {
          result = acc + cur.normal
        } else if (cur.is_checked === 'bad') {
          result = acc + cur.bad
        } else {
          result = acc
        }

        this.$emit('update-value', result);
        return result;
      }, 0)
    }
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  //border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: $border;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  border-left: $border;

  .item-title {
    padding: 10px;
    border-right: $border;
    border-bottom: $border;
  }

  .item-content {
    padding: 10px;
    align-self: center;
    color: #3c3c3c;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }

    .row-title {
      font-weight: 500;
      display: inline-flex;
    }
    .row-title:before {
      content: "•";
      display: inline-block;
      width: 1em;
      margin-left: 1em;
    }

    .row-title-nodot {
      font-weight: 500;
      display: inline-flex;
    }
  }
  .item-box {
    border-left: $border;
    //border-right: $border;
    display: flex;
    .item-box-check {
      justify-content: center !important;
      display: flex;
      align-self: center;
      width: 100%;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
    .item-box-center {
      width: 100%;
      align-self: center;
      text-align: center;
    }
  }
  .item-box:last-child {
    border-right: $border;
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }

  .item-note {
    padding: 5px;
    border-left: $border;
    height: 100%;
    display: inline-flex;
    align-items: center;
  }
}

.row-content__body-item:last-child {
  border-bottom: $border;
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}
/*체크박스 중앙 정렬을 위함.. scope style 내에서는 적용이 안되서 외부로 뺐음*/
.row-content__body-item .item-box .vs-checkbox {
  margin-right: 0;
}
</style>
